import React from 'react';
import logo from '../assets/logo.png';

interface BrandMarkProps {
  className?: string;
}

export const BrandMark: React.FC<BrandMarkProps> = ({ className = '' }) => (
  <img
    src={logo}
    alt="3RDI logo"
    className={`object-contain ${className}`}
    draggable={false}
  />
);
